export enum LeadsPageKind {
  Leads = 0,
  Clients = 1,
}
